import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../../shared/services/global.service';
import {ProgramService} from '../../../../shared/services/program.service';
import {ActivatedRoute} from '@angular/router';
import {UniversityMarketingTagService} from '../../../../shared/services/university-marketing-tag.service';

@Component({
    selector: 'app-add-university-marketing-tag',
    templateUrl: './add-university-marketing-tag.component.html',
    styleUrls: ['./add-university-marketing-tag.component.scss']
})
export class AddUniversityMarketingTagComponent implements OnChanges {
    addUniversityMarketingTagForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    universityId: any;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                public universityMarketingTagService: UniversityMarketingTagService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnChanges(): void {
        this.universityId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-university-marketing-tag').toggleOpen();
    }

    refresh() {
        this.addUniversityMarketingTagForm = this.fb.group({
            'title': ['', [Validators.required, Validators.pattern(/\S/)]],
            'description': [''],
            'keywords': [''],
            'canonical': [''],
            'author': [''],

        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addUniversityMarketingTagForm.patchValue({
            'title': (this.data && this.data['title']) ? this.data['title'] : '',
            'description': (this.data && this.data['description']) ? this.data['description'] : '',
            'keywords': (this.data && this.data['keywords']) ? this.data['keywords'] : '',
            'canonical': (this.data && this.data['canonical']) ? this.data['canonical'] : '',
            'author': (this.data && this.data['author']) ? this.data['author'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addUniversityMarketingTagForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'title': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.title) ? this.addUniversityMarketingTagForm.value.title : '',
                'description': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.description) ? this.addUniversityMarketingTagForm.value.description : '',
                'keywords': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.keywords) ? this.addUniversityMarketingTagForm.value.keywords : '',
                'canonical': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.canonical) ? this.addUniversityMarketingTagForm.value.canonical : '',
                'author': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.author) ? this.addUniversityMarketingTagForm.value.author : '',
            };
            this.submitting = true;
            this.universityMarketingTagService.create(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addUniversityMarketingTagForm.reset();
                    this.addUniversityMarketingTagForm.patchValue({
                        'title': '',
                        'description': '',
                        'keywords': '',
                        'canonical': '',
                        'author': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].title && error['error']['errors'].title.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].title[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addUniversityMarketingTagForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'title': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.title) ? this.addUniversityMarketingTagForm.value.title : '',
                'description': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.description) ? this.addUniversityMarketingTagForm.value.description : '',
                'keywords': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.keywords) ? this.addUniversityMarketingTagForm.value.keywords : '',
                'canonical': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.canonical) ? this.addUniversityMarketingTagForm.value.canonical : '',
                'author': (this.addUniversityMarketingTagForm.value && this.addUniversityMarketingTagForm.value.author) ? this.addUniversityMarketingTagForm.value.author : '',
            };
            this.submitting = true;
            this.universityMarketingTagService.update(this.data['id'],params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
